import type { QueryType } from "@/common/types/common";
import type { TermPayloadType } from "@/common/types/term/term";

import clientAxios from "../../client";
import { formatQueryString } from "@/common/utils/common";

export async function termList(query?: QueryType) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`term/list${queryString}`);
}

export async function termGet(term_id: string) {
	return await clientAxios.get(`term/${term_id}/show`);
}

export async function termCreate(payload: TermPayloadType) {
	return await clientAxios.post(`term/create`, payload);
}

export async function termUpdate(term_id: string, payload: TermPayloadType) {
	return await clientAxios.put(`term/${term_id}/update`, payload);
}

export async function termPatch(
	term_id: string,
	payload: Partial<TermPayloadType>,
) {
	return await clientAxios.patch(`term/${term_id}/patch`, { payload });
}

export async function termDelete(term_id: string) {
	return await clientAxios.del(`term/${term_id}/delete`);
}
